import { createSelector, createSlice } from '@reduxjs/toolkit';
import {
  NOTIFICATION_SOURCE_SESSION,
} from '@avtechsoftware/ra-javascript-utilities/src/types/ToastNotificationSourceTypes';
import HtmlToReactInstructions
  from '@avtechsoftware/react-component-library/src/utility/HtmlToReactInstructions';
import { Parser as HtmlToReactParser } from 'html-to-react';
import { sessionHash } from '../../../utility/remoteServiceUtil';

const htmlToReactParser = new HtmlToReactParser();

const selectAllToastNotifications = createSelector([
  (state) => state.toastNotifications],
(slice) => {
  const sessionMessageList = [...slice.messageList];
  sessionMessageList.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  return sessionMessageList.map((message) => ({
    id: message.id,
    level: message.level,
    timestamp: message.timestamp,
    title: htmlToReactParser.parseWithInstructions(
      message.title.replace('AUTH_TOKEN', sessionHash), () => true, HtmlToReactInstructions,
    ),
    body: htmlToReactParser.parseWithInstructions(
      message.body.replace('AUTH_TOKEN', sessionHash), () => true, HtmlToReactInstructions,
    ),
    source: message.source,
    duration: message.duration,
  }));
});

const initialState = {
  loading: true,
  loadingError: false,
  messageList: [],
};

const jwtSlice = createSlice({
  name: 'toastNotifications',
  initialState,
  reducers: {
    pushSessionMessage: (state, action) => {
      const {
        level, title, body, durationInMillis = 5000,
      } = action.payload;
      const id = Math.floor(Date.now() + Math.random());
      const newMessage = {
        id,
        level,
        timestamp: new Date().toLocaleString(),
        title,
        body,
        source: NOTIFICATION_SOURCE_SESSION,
        duration: durationInMillis,
      };
      state.messageList.push(newMessage);
    },
    dismissMessage: (state, action) => {
      const id = action.payload;
      state.messageList = state.messageList.filter((message) => message.id !== id);
    },
    dismissAllMessages: (state) => {
      state.messageList = [];
    },
  },
});

const { actions, reducer } = jwtSlice;

export const { dismissMessage, pushSessionMessage, dismissAllMessages } = actions;
export {
  selectAllToastNotifications,
};
export default reducer;
